import { render, staticRenderFns } from "./AusFooterContent.vue?vue&type=template&id=fb4ea35a"
import script from "./AusFooterContent.vue?vue&type=script&lang=js"
export * from "./AusFooterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports